import __request__ from 'routing/request';
interface MultiValueBin_NamedBinDefinition {
    readonly values: number[];
    readonly bin_definition: NamedBinDefinition;
}
interface NamedBinDefinition {
    readonly bin_name: string;
}
interface Histogram {
    readonly schema: string[];
    readonly bins: MultiValueBin_NamedBinDefinition[];
}
/**
 * Get timerange-based histogram of queries durations and percentage in recent query population
 */
export function getQueryDurationHistogram(): Promise<Histogram> {
    return __request__('GET', '/system/monitoring/query_duration_histogram', null, {}, {
        'Accept': [
            'application/json',
            'text/csv'
        ]
    });
}
